import React, { useMemo, useState, useEffect }from 'react';
import {
  Create, SimpleForm, TextInput, AutocompleteArrayInput, Button, SelectArrayInput, SelectInput,
  NumberInput, ReferenceArrayInput, Filter, Edit, List,Datagrid, TextField, DateField, required, minValue,
  useNotify, useRefresh, Toolbar, SaveButton, FormDataConsumer, BooleanInput, NumberField, Labeled, FunctionField,
} from 'react-admin';
import DeleteWithConfirmation from '../components/DeleteWithConfirmation';
import { NotificationManager } from 'react-notifications';
import { fetchUtils } from 'react-admin';
import { NoBidChartComponent } from '../components/chart';
import { EmptyList } from '../components/empty';
import authProvider from '../authProvider';
import { makeStyles } from '@material-ui/core/styles';
import { Accordion, AccordionSummary, AccordionDetails, Checkbox, FormControlLabel, LinearProgress, Card, Dialog,
  DialogTitle, DialogContent, DialogActions, CircularProgress, Box } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import FilterCardTitle from '../common/filters/FilterCardTitle';
import ToggleButton from '@material-ui/lab/ToggleButton';
import { useForm, useFormState, FormSpy } from 'react-final-form';
import { Add, Remove} from '@material-ui/icons';
import SplitButton from '../components/SplitButton.js';
import { DisclaimerComponent } from '../components/disclaimer.js';

const utils = require('../components/utils');

const fetch = fetchUtils.fetchJson;
const BASE_URL = window.nobid_endpoint + '/carbon/realtime_report?';
const countryChoices = require('../components/countries.json');
// let highlightToday = true;
const choicesInterval = [
  { id: 'm', name: 'Minutes' },
  { id: 'h', name: 'Hour' },
  { id: 'd', name: 'Day' }
];
const choicesType = [
  { id: "CP", name: "$Revenue" },
  { id: "RPM", name: "$RPM" },
  { id: "IM", name: "#Impressions" },
  { id: "CPM", name: "$Average CPM" },
  { id: "AR", name: "#Ad Requests" },
  { id: "BR", name: "#Bid Requests" },
  { id: "BS", name: "#Bid Reponses" },
  // { id: "BRR", name: "#Requests Rate (BR/AR)" },
];
const choicesTypePublisher = [
  { id: "CP", name: "$Revenue" },
  { id: "RPM", name: "$RPM" },
  { id: "IM", name: "#Impressions" },
  { id: "CPM", name: "$Average CPM" },
  { id: "AR", name: "#Ad Requests" },
  { id: "BR", name: "#Bid Requests" },
  { id: "BS", name: "#Bid Reponses" },
];
function getChoicesType (permissions) {
  if (permissions?.role==='admin') return choicesType;
  else return choicesTypePublisher;
}
const choicesTimeRange = [
  { id: 1, name: '1 Hour' },
  { id: 2, name: '2 Hours' },
  { id: 3, name: '3 Hours' },
  { id: 4, name: '4 Hours' },
  { id: 5, name: '5 Hours' },
  { id: 8, name: '8 Hours' },
  { id: 10, name: '10 Hours' },
  { id: 12, name: '12 Hours' },
  { id: 24, name: '24 Hours' },
  { id: 28, name: '28 Hours' },
  { id: 30, name: '30 Hours' },
  { id: 36, name: '36 Hours' },
  { id: 2 * 24, name: '2 Days' },
  { id: 3 * 24, name: '3 Days' },
  { id: 4 * 24, name: '4 Days' },
  { id: 5 * 24, name: '5 Days' },
  { id: 6 * 24, name: '6 Days' },
  { id: 7 * 24, name: '7 Days' },
  { id: 8 * 24, name: '8 Days' },
  { id: 9 * 24, name: '9 Days' },
  { id: 10 * 24, name: '10 Days' }
]

const choicesDevices = [
  { id: 'COMPUTER', name: 'Desktop' },
  { id: 'MOBILE', name: 'Mobile' },
  { id: 'TABLET', name: 'Tablet' },
  { id: 'DIGITAL MEDIA RECEIVER', name: 'Digital media receiver' },
  { id: 'UNKNOWN', name: 'Unknown' },
]

const choicesBrowsers = [
  { id: 'Chrome', name: 'Chrome' },
  { id: 'Safari', name: 'Safari' },
  { id: 'Apple Webkit', name: 'Apple Webkit' },
  { id: 'Firefox', name: 'Firefox' }
]

const chartFormatChoices = [
  { id: 'column', name: 'Bars' },
  { id: 'area', name: 'Area' },
  { id: 'line', name: 'Lines' },
  { id: 'spline', name: 'Smoothed' },
];

const submitOptions = [
  'Run Report',
  'Run Report With Rankings'
];

const useStyles = makeStyles({
  topList: {
    'MuiCheckbox-root': {
      height: '0px'
    }
  },
  topLabel: {
    '& .MuiFormControlLabel-label': {
      width: '100%',
      fontSize: '12px'
    }
  },
  checkBoxSize: {
    '& .MuiSvgIcon-root': {
      height: '15px',
      width: '15px'
    }
  },
  progressBarCustom: {
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: "limeGreen"
    }
  }
});

const hasActiveFilters = (record) => {
  const filters = ['tldomain', 'adomain', 'campaign_id', 'device', 'country', 'publisher_id', 'site_id', 'browser',
    'bidder_id']
  return record && filters.some( f => record[f] && record[f].length > 0)
}

const prebidBidders = require('../prebidBidderModules.json');

// const hasActiveAlerter = (record) => record?.alerter?.active;
// const isAlerterActive = (form) => form.watcher && form.watcher.active === true ? required() : []

const CustomFilter = ({ name, source, reference, selectedEntity, handleEntityInputChanged, choices, loading, optionText = 'name' }) => {
  function searchFilter (searchText) {
    const formData = form?.getState()?.values;
    if (source==='site_id' && formData?.publisher_id?.length > 0) return { search_name: searchText, publisher_id: formData.publisher_id };
    else return { search_name: searchText };
  }
  const form = useForm();
  if (selectedEntity.size > 0) form.change(source, [...selectedEntity])
  return choices ?                            
    <AutocompleteArrayInput label={name}
      source={source}
      allowEmpty
      choices={choices}
      onChange={handleEntityInputChanged}
      disabled={loading}
      optionText={optionText}
      optionValue="id"
      fullWidth /> :
    <ReferenceArrayInput
      source={source}
      reference={reference}
      basePath={name.toLowerCase()}
      perPage={15}
      sort={{ field: 'name', order: 'ASC' }}
      filterToQuery={searchFilter}
      allowEmpty
      onChange={handleEntityInputChanged}
      disabled={loading}
      fullWidth>
      <AutocompleteArrayInput disabled={loading} label={name} optionText={optionText} optionValue="code"
      style={{maxWidth: '50px', maxHeight: '100px'}}/>
    </ReferenceArrayInput>
}

class RealtimeChartComponent extends React.Component {
  state = {
    data: [],
    dataToday: [],
    dataYesterdays: {},
    dataTodayOverYesterdays: {},
    loading: false,
    params: {},
    baseUrl: BASE_URL,
    publisherChoices: [],
    siteChoices: [],
    bidderChoices: [],
    selectedPublishersExclude: false,
    selectedPublishers: new Set(),
    selectedSitesExclude: false,
    selectedSites: new Set(),
    selectedBiddersExclude: false,
    selectedBidders: new Set(),
    rankingsDisplay: false,
    results: undefined,
    max: 0,
    min: 0,
    dataPoints: 4,
    emails: ''
  };

  defaultMetricType = 'CP'

  constructor(props) {
    super(props);
    this.state.params.type = this.defaultMetricType
    this.defaultMinMaxValue = 50;
  }

  handleChartThresholdLineChanged = (value) => {
    this.updateChart(choicesType, chartFormatChoices, { thresholdLine: value.target.value });
  }

  handleChartFormatChanged = (value) => {
    this.updateChart(choicesType, chartFormatChoices, { format: value.target.value });
  }

  // handleChartHighlightTodayChanged = (value) => {
  //   highlightToday = value;
  //   let data = [...this.state.dataYesterdays, ...this.state.dataToday];
  //   if (highlightToday) {
  //     data = [...this.state.dataTodayOverYesterdays, ...data];
  //   }
  //   this.state.data = data;
  //   this.setState({ data: data });
  //   this.clearChart();
  //   this.updateChart(chartMetricsChoices, chartFormatChoices);
  // }

  clearChart () {
    this.refs.nobidRealtimeChart.clearChart();
  }

  updateChart = function (chartMetricsChoices, chartFormatChoices, options) {
    this.refs.nobidRealtimeChart.clearChart();
    this.refs.nobidRealtimeChart.refreshChart(this.state.data, chartMetricsChoices, chartFormatChoices, options);
  }

  updateState(results, limits, dataType) {
    function getDay (dateStr) {
      const date = new Date(dateStr);
      var d = date.getDate();
      var m = date.getMonth() + 1;
      var y = date.getFullYear();
      const day = '' + y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
      return day;
    }
    function getTime (dateStr) {
      const date = new Date(dateStr);
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      const day = '' + (h<=9 ? '0' + h : h) + ':' + (m<=9 ? '0' + m : m) + ':' + (s <= 9 ? '0' + s : s);
      return day;
    }
    results = JSON.parse(results.body);
    let data = [];
    if (results && results.schema && results.datarows) {
      for (let i in results.datarows) {
        let o = {};
        for (let j in results.datarows[i]) {
          let d = results.datarows[i][j];
          let key = results.schema[j].name;
          // if (key==='date') d += ' UTC';
          o[key] = d;
        }
        data.push(o);
      }
    }

    const smooth = (limits?.max || limits?.min) ? results?.smooth?.map(x => {
      const o = {
        date: x[0],
        _color: 'red',
        _type: 'line',
        today: 'Smooth',
        _zindex: 4,
      }
      o[results.schema[1].name] = x[1];
      return o;
    }) : [];

    const maRange = (limits?.max || limits?.min) ? results?.smooth?.map(x => {
      const o = {
        date: x[0],
        // _color: '#43ff6459',
        _color: '#dddddd80',
        _type: 'arearange',
        today: 'Range',
        _zindex: 2
      }
      o[results.schema[1].name] = [x[1]];
      // o[results.schema[1].name] = [x[1]-(x[1]*(Number(limits.min)/100)), x[1]*((Number(limits.max)/100)+1)];
      return o;
    }) : [];

    const todaysDate = data && data.length > 0 ? data[data.length-1].date : '';
    const todaysSeries = [];
    const otherDaysSeries = [];
    let todayOverYesterdaysSeries = [];
    if (todaysDate) {
      const todaysDay = getDay(todaysDate);
      for (const d of data) {
        const day = getDay(d.date);
        if (day === todaysDay) {
          d._color = 'yellow';
          d.today = 'Now';
          d._zindex = 2;
          if (!this.state.params || !this.state.params.interval || this.state.params.interval === 'h') d._dataLabels = {enabled: true, color: 'white'};
          todaysSeries.push(d);
        } else {
          otherDaysSeries.push(d);
        }
      }
      if (todaysSeries.length>0) {
        for (const d of data) {
          const day = getDay(d.date);
          const time = getTime(d.date);
          if (day !== todaysDay) {
            for (let i=0; i<todaysSeries.length-1; i++) {
              const todaysSerie = todaysSeries[i];
              const todaysSerieTime = getTime(todaysSerie.date);
              const todaysSerieDay = getDay(todaysSerie.date);
              if (todaysSerieTime === time) {
                const clone = JSON.parse(JSON.stringify(todaysSerie));
                const a = clone.date.split('T');
                if (a && a.length > 1) {
                  a[0] = day;
                  a[1] = time;
                  clone.date = `${a[0]}T${a[1]}`;
                  clone.today = 'Today';
                  clone._color = 'yellow';
                  clone._type = 'scatter';
                  if (!this.state.params || !this.state.params.interval || this.state.params.interval === 'h') clone._dataLabels = {enabled: true, color: 'white'};
                  clone._zindex = 7;
                  todayOverYesterdaysSeries.push(clone);
                }
              }
            }
          }
        }
      }
    }
    data = [...todayOverYesterdaysSeries, ...otherDaysSeries, ...todaysSeries];
    const newStateObject = {
      dataToday: todaysSeries,
      dataYesterdays: otherDaysSeries,
      dataTodayOverYesterdays: todayOverYesterdaysSeries,
      smooth: smooth,
      maRange: maRange,
      data: data,
      loading: false,
    }
    newStateObject.rankingsDisplay = this.state.params.chart_rankings ? true : false;
    if (results.publishers) newStateObject.publisherChoices =  results.publishers;
    if (results.sites) newStateObject.siteChoices =  results.sites;
    if (results.bidders) newStateObject.bidderChoices =  results.bidders;

    this.setState(newStateObject);
    if (!dataType) this.refs.nobidRealtimeChart.refreshChart(data, choicesType, chartFormatChoices, { metric: this.state.params['type']}, true);
  }

  fetchData(dataType) {
    const newState = { loading: true };
    this.setState(newState);
    let previewParams;
    if (dataType === 'preview') {
      previewParams = {...this.state.params}
      previewParams.interval = 'm';
      previewParams.time_range = 1.25;
    }
    const queryString = new URLSearchParams(previewParams || this.state.params);
    let url = `${this.state.baseUrl}${queryString}`;
    let options = { headers: new Headers() };
    options.headers.set('accept', 'application/json');
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, options).then((response) => {
      return response;
    }).then((results) => {
      dataType ? this.updateState(results, { min: this.state.min, max: this.state.max }, dataType) :
        this.updateState(results);
    });
  }

  componentDidMount() {
    [['publisher_id', 'Publishers'], ['site_id', 'Sites'], ['bidder_id', 'Bidders']].forEach(x => 
      this.newHandleFilterChanged(this.props?.record?.[x[0]], `selected${x[1]}`, x[0])
    );

    [['publisher_exclude', 'Publishers'],['site_exclude', 'Sites'], ['bidder_exclude', 'Bidders']].forEach(x =>
      this.toggleExclude(x[0], `selected${x[1]}Exclude`, !this.props?.record?.[x[0]])
    );

    ['time_range', 'interval', 'tldomain', 'adomain', 'campaign_id', 'metric', 'country', 'device', 'type'].forEach(x => 
      this.handleFilterChanged(this.props?.record?.[x], x)
    );

    ['min', 'max'].forEach(x => this.state[x] =this.props?.record?.alerter?.[x] || this.defaultMinMaxValue);

    this.state.dataPoints = this.props?.record?.alerter?.['data_points'] || this.state.dataPoints;
    this.state.emails = this.props?.record?.alerter?.['emails'] || this.state.emails;
  }

  handleClick = () => {
    this.fetchData();
  }

  handleSubmitChange = (v) => {
    this.state.params['chart_rankings'] = v === 0 ? false : true
  }

  handlePublisherInputChanged = (values) => {
    this.newHandleFilterChanged(values, 'selectedPublishers', 'publisher_id')
  }

  handleCampaignInputChanged = (values) => {
    this.handleFilterChanged(values, 'campaign_id');
  }

  handleSiteInputChanged = (values) => {
    this.newHandleFilterChanged(values, 'selectedSites', 'site_id')
  }

  handleBidderInputChanged = (values) => {
    this.newHandleFilterChanged(values, 'selectedBidders', 'bidder_id')
  }

  handlePublisherInteract = (e) => {
    this.handleCheckBoxChanged(e.target.value, e.target.checked, 'selectedPublishers', 'publisher_id')
  }

  handleSiteInteract = (e) => {
    this.handleCheckBoxChanged(e.target.value, e.target.checked, 'selectedSites', 'site_id')
  }
  handleBidderInteract = (e) => {
    this.handleCheckBoxChanged(e.target.value, e.target.checked, 'selectedBidders', 'bidder_id')
  }

  handlePublisherClickAll = (e) => {
    this.setState({ selectedPublishers: new Set(e.target.checked ? this.state.publisherChoices.map(p => p.id) : []) })
  }

  handleSiteClickAll = (e) => {
    this.setState({ selectedSites: new Set(e.target.checked ? this.state.siteChoices.map(p => p.id) : []) })
  }

  handleBidderClickAll = (e) => {
    this.setState({ selectedBidders: new Set(e.target.checked ? this.state.bidderChoices.map(p => p.id) : []) })
  }

  handleCheckBoxChanged = (value, checked, filter, qsParam) => {
    const filterDataSet = this.state[filter]
    checked ? filterDataSet.add(isNaN(Number(value)) ? value : Number(value)) : filterDataSet.delete(isNaN(Number(value)) ? value : Number(value))
    this.state.params[qsParam] = [...filterDataSet]
    this.setState({ filter: filterDataSet })
  }

  newHandleFilterChanged = (values, filter, qsParam) => {
    if (values) {
      const o = {};
      o[filter] = new Set(values)
      this.state.params[qsParam] = values
      this.setState(o)
    }
  }

  handleFilterChanged = (values, thekey) => {
    if (values) { this.state.params[thekey] = values }
  }

  handleInputChanged = (value) => {
    this.handleFilterChanged(value.target.value, value.target.name);
  }

  handleCountryChanged = (value) => {
    this.handleFilterChanged(value, 'country');
  }

  handleMerticChanged = (value) => {
    window.selectedChartMetric = { id: value.target.value, name: choicesType.find(x => x.id === value.target.value).name };
    this.handleFilterChanged(value.target.value, value.target.name);
  }

  handleIntervalChanged = (value) => {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (value.target.value > 0) {
      const interval = value.target.value * 60 * 1000;
      var self = this;
      this.timer = setInterval(function () {
        self.fetchData();
      }, interval);
    }
  }

  toggleExclude = (qsParam, stateParam, v, form) => {
    if(form) form.change(qsParam, !v);
    const o = {};
    o[stateParam] = !v
    this.state.params[qsParam] = !v
    this.setState(o)
  }

  validateTimeRange = (allvalues) => {
    const errors = {};
    if (allvalues.time_range > 72 && allvalues.interval === 'm') {
      errors.time_range = 'Cannot use minutes interval for values above 3 days'
    }
    return errors;
  }

  render() {
    const { permissions } = this.props;
    return (
      <div>
        <SimpleForm toolbar={<CustomToolbar parent={this} />}  validate={this.validateTimeRange} {...this.props}>
          <TextInput source="name" label="Report Name" style={{ width: '400px' }} disabled={this.state.loading} validate={required()} />
          <div style={{ width: '100%', overflow: 'hidden' }} id="wrapper2">
            <div style={{ float: 'left', paddingRight: '5px' }}>
              <SelectInput label="Interval" source="interval" choices={choicesInterval} initialValue='h'
                onChange={this.handleInputChanged} disabled={this.state.loading} />
            </div>

            <div style={{ float: 'left', paddingRight: '5px' }}>
              <SelectInput label="Time Range" source="time_range" choices={choicesTimeRange} initialValue={3*24}
                onChange={this.handleInputChanged} disabled={this.state.loading} />
            </div>

            <div style={{ float: 'left', paddingRight: '5px' }}>
              <SelectInput label="Metric" source="type" choices={getChoicesType(permissions)}
                onChange={this.handleMerticChanged} disabled={this.state.loading} initialValue={this.defaultMetricType} />
            </div>

            <div style={{ float: 'right', paddingLeft: '10px' }}>
              {permissions?.role!=='publisher' &&
              <SelectInput label="Refresh Every"
                source='refresh_interval'
                choices={[
                  { id: "0", name: "- None -" },
                  { id: "1", name: "1 minute" },
                  { id: "5", name: "5 minutes" },
                  { id: "10", name: "10 minutes" },
                  { id: "15", name: "15 minutes" },
                  { id: "20", name: "20 minutes" },
                  { id: "30", name: "30 minutes" },
                ]}
                disabled={this.state.loading}
                onChange={this.handleIntervalChanged}
                style={{ paddingRight: '5px' }}
              />
              }
            <div style={{ float: 'right' }} >
              <SelectInput label="Chart Format"
                source='format'
                choices={chartFormatChoices}
                defaultValue={'column'}
                onChange={this.handleChartFormatChanged}
                disabled={this.state.loading}
                style={{ paddingRight: '5px', float: 'left' }}
              />
              <NumberInput label="Threshold Line"
                source='threshold_line'
                onChange={this.handleChartThresholdLineChanged}
                disabled={this.state.loading}
                style={{ paddingRight: '5px', float: 'left' }}
              />
            </div>
            </div>
          </div>

          <Accordion defaultExpanded={false} style={{ marginBottom: '20px', backgroundColor: '#3e3e3e'}} fullWidth>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <FilterCardTitle title="Filters" values={hasActiveFilters(this.props.record)} />
            </AccordionSummary>
            <AccordionDetails>
              <div style={{ width: '100%' }}>
                <div style={{ display: 'flex', width: '100%', overflow: 'hidden', columnGap: '10px' }} id="wrapper3">
                  <div style={{ flex: 1 }}>
                    <AutocompleteArrayInput label="Browsers"
                      source="browser"
                      allowEmpty
                      emptyText='- None -'
                      choices={choicesBrowsers}
                      onChange={this.handleInputChanged}
                      disabled={this.state.loading} 
                      fullWidth />
                  </div>

                  <div style={{ flex: 1 }}>
                    <AutocompleteArrayInput label="Devices"
                      source="device"
                      allowEmpty
                      emptyText='- None -'
                      choices={choicesDevices}
                      onChange={this.handleInputChanged}
                      disabled={this.state.loading} 
                      fullWidth />
                  </div>

                  <div style={{ flex: 1 }}>
                    <AutocompleteArrayInput label="Countries"
                      source="country"
                      allowEmpty
                      emptyText='- None -'
                      choices={countryChoices}
                      onChange={this.handleCountryChanged}
                      disabled={this.state.loading} fullWidth />
                  </div>
                </div>
                <div style={{ display: 'flex', width: '100%', overflow: 'hidden', columnGap: '10px' }} id="wrapper4">
                  <FormSpy subscription={{ pristine: true }}>
                    {(props) => {
                      return (
                        <div style={{display: 'flex', columnGap: '15px', width: '100%'}}>
                          <div style={{flex: 1,  display: 'flex'}}>
                            <ToggleButton
                              style={{height: '48px', marginTop: '8px', color: 'white', backgroundColor: this.state.selectedPublishersExclude ? 'orangered' : 'green'}}
                              value={this.state.selectedPublishersExclude}
                              selected={this.props.record?.publisher_exclude}
                              onChange={(e, v) => this.toggleExclude('publisher_exclude', 'selectedPublishersExclude', v, props.form)}
                            >
                              { this.state.selectedPublishersExclude ? <Remove /> : <Add /> }
                            </ToggleButton>

                            <CustomFilter name='Publishers' source='publisher_id' reference='publishers' loading={this.state.loading}
                              selectedEntity={this.state.selectedPublishers}
                              handleEntityInputChanged={this.handlePublisherInputChanged} />
                          </div>

                          <div style={{flex: 1, display: 'flex'}}>              
                            <ToggleButton
                              style={{height: '48px', marginTop: '8px', color: 'white', backgroundColor: this.state.selectedSitesExclude ? 'orangered' : 'green'}}
                              value={this.state.selectedSitesExclude}
                              selected={this.state.selectedSitesExclude}
                              onChange={(e, v) => this.toggleExclude('site_exclude', 'selectedSitesExclude', v, props.form)}
                            >
                              { this.state.selectedSitesExclude ? <Remove /> : <Add /> }
                            </ToggleButton>

                            <CustomFilter name='Sites' source='site_id' reference='sites' loading={this.state.loading}
                              selectedEntity={this.state.selectedSites} optionText={ x => utils.formatSiteName(x) }
                              handleEntityInputChanged={this.handleSiteInputChanged} />
                          </div>

                          <div style={{flex: 1,  display: 'flex'}}>
                            <ToggleButton
                              style={{height: '48px', marginTop: '8px', color: 'white', backgroundColor: this.state.selectedBiddersExclude ? 'orangered' : 'green'}}
                              value={this.state.selectedBiddersExclude}
                              selected={this.state.selectedBiddersExclude}
                              onChange={(e, v) => this.toggleExclude('bidder_exclude', 'selectedBiddersExclude', v, props.form)}
                            >
                              { this.state.selectedBiddersExclude ? <Remove /> : <Add /> }
                            </ToggleButton>
                            <CustomFilter name='Bidders' source='bidder_id' choices={prebidBidders} loading={this.state.loading}
                              selectedEntity={this.state.selectedBidders} handleEntityInputChanged={this.handleBidderInputChanged} />
                          </div>
                        </div>
                      )
                    }}
                  </FormSpy>
                </div>
              </div>
            </AccordionDetails>
          </Accordion>
        </SimpleForm>

        <div style={{ display: 'flex' }}>
          { this.state.rankingsDisplay &&
            <Card style={{ margin: '15px 15px 0 0', padding: '0 0 10px 10px', display: this.state.rankingsDisplay }}>
              <div style={{ width: '250px', maxHeight: '65vh', display: 'flex', flexDirection: 'column', overflowY: 'scroll', overflowX: 'hidden', margin: '5px 10px 0 0' }} >
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={this.handlePublisherClickAll}
                        name="publisherCheckboxes"
                        color="primary"
                        disabled={this.state.loading}
                      />
                    }
                    label="Top 20 Publishers"
                  />
                  <div style={{ margin: '0 0 15px 15px', maxHeight: '170px', overflowY: 'scroll', overflowX: 'clip' }}>
                    {this.state.publisherChoices.map(p =>
                      <div style={{ marginTop: '10px' }}>
                        <FormControlLabel
                          style={{ width: '104%' }}
                          className={this.props.classes.topLabel}
                          control={
                            <Checkbox
                              value={p.id}
                              className={this.props.classes.checkBoxSize}
                              checked={this.state.selectedPublishers.has(p.id)}
                              onChange={this.handlePublisherInteract}
                              name={p.name}
                              color="primary"
                              style={{ height: '0px' }}
                              disabled={this.state.loading}
                            />
                          }
                          label={
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                              <span>{p.name}</span>
                              <span>{`${p.ratio}%`}</span>
                            </div>
                          }
                        />
                        <LinearProgress style={{ backgroundColor: 'darkGreen' }}
                          className={this.props.classes.progressBarCustom}
                          variant="determinate"
                          value={p.ratio} />
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={this.handleSiteClickAll}
                        name="siteCheckboxes"
                        color="primary"
                        disabled={this.state.loading}
                      />
                    }
                    label="Top 20 Sites"
                  />

                  <div style={{ margin: '0 0 15px 15px', maxHeight: '170px', overflowY: 'scroll', overflowX: 'clip' }}>
                    {this.state.siteChoices.map(p =>
                      <div style={{ marginTop: '10px' }}>
                        <FormControlLabel
                          style={{ width: '104%' }}
                          className={this.props.classes.topLabel}
                          control={
                            <Checkbox
                              value={p.id}
                              className={this.props.classes.checkBoxSize}
                              checked={this.state.selectedSites.has(p.id)}
                              onChange={this.handleSiteInteract}
                              name={p.name}
                              color="primary"
                              style={{ height: '0px' }}
                              disabled={this.state.loading}
                            />
                          }
                          label={
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                              <span>{p.name}</span>
                              <span>{`${p.ratio}%`}</span>
                            </div>
                          }
                        />
                        <LinearProgress style={{ backgroundColor: 'darkGreen' }}
                          className={this.props.classes.progressBarCustom}
                          variant="determinate"
                          value={p.ratio} />
                      </div>
                    )}
                  </div>
                </div>
                
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={this.handleBidderClickAll}
                        name="bidderCheckboxes"
                        color="primary"
                        disabled={this.state.loading}
                      />
                    }
                    label="Top 20 Bidders"
                  />

                  <div style={{ margin: '0 0 15px 15px', maxHeight: '170px', overflowY: 'scroll', overflowX: 'clip' }}>
                    {this.state.bidderChoices.map(p =>
                      <div style={{ marginTop: '10px' }}>
                        <FormControlLabel
                          style={{ width: '104%' }}
                          className={this.props.classes.topLabel}
                          control={
                            <Checkbox
                              value={p.id}
                              className={this.props.classes.checkBoxSize}
                              checked={this.state.selectedBidders.has(p.id)}
                              onChange={this.handleBidderInteract}
                              name={p.name}
                              color="primary"
                              style={{ height: '0px' }}
                              disabled={this.state.loading}
                            />
                          }
                          label={
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                              <span>{prebidBidders.find(x=>x.id===p.id)?.name}</span>
                              <span>{`${p.ratio}%`}</span>
                            </div>
                          }
                        />
                        <LinearProgress style={{ backgroundColor: 'darkGreen' }}
                          className={this.props.classes.progressBarCustom}
                          variant="determinate"
                          value={p.ratio} />
                      </div>
                    )}
                  </div>

                </div>
                
              </div>
            </Card>
          }
          <div style={{ flexGrow: 1 }}>
            <span style={{ fontSize: 'smaller', float: 'right' }}>Local timezone</span>
            <NoBidChartComponent ref="nobidRealtimeChart" authProvider={authProvider}
              config={{ height: '40%', min: 0, xformat: '%e-%b %H:%M', color: 'limegreen' }} />
          </div>
        </div>
      </div>
    );
  }
}

const CustomToolbar = ({ parent, ...props }) => {
  return (
    <Toolbar>
      <SaveButton style={{marginRight: '25px'}} variant='contained' 
        color='primary' disabled={parent.state.loading} {...props} />
      {/* <Button onClick={parent.handleClick} label='Run Report  ' className='MuiButton-containedPrimary' style={{height: '33px'}} disabled={parent.state.loading}/> */}
      <SplitButton options={submitOptions} style={{ height: "33px" }} color="primary" disabled={parent.state.loading}
        variant="contained" onClick={parent.handleClick} onChange={parent.handleSubmitChange} />      
    </Toolbar>
  )
}

const RealtimeDashboardTitle = ({ record }) => {
  return <span>Realtime Dashboard {record ? `"${record.name}"` : ''}</span>;
};

const ListFilters = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="search_name" alwaysOn resettable />
  </Filter>
);

export const CarbonRealtimeReportEdit = (props) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const onSuccess = ({data}) => {
    notify(`Changes to Realtime Dash were saved.`);
    refresh();
  }
  const classes = useStyles(props);
  return (
    <>
      <Edit title={<RealtimeDashboardTitle />} onSuccess={onSuccess} mutationMode='pessimistic' {...props}>
        <RealtimeChartComponent formType="edit" classes={classes} authProvider={props.authProvider} permissions={props.permissions} {...props} />
      </Edit>
      <DisclaimerComponent />
    </>
  );
};

export const CarbonRealtimeReportCreate = (props) => {
  const classes = useStyles(props);
  return (
    <>
      <Create title="Create Realtime Dashboard" {...props}>
        <RealtimeChartComponent formType="create" classes={classes} authProvider={props.authProvider} permissions={props.permissions} {...props} />
      </Create>
      <DisclaimerComponent />
    </>
  );
};

export const CarbonRealtimeReportList = ({ permissions, ...props }) => (
  <List {...props} empty={<EmptyList name="Analytics Realtime"/>} title="Realtime Dashboards" perPage={25} bulkActionButtons={false} filters={<ListFilters />} 
  exporter={false} >
    <Datagrid rowClick="edit">
      <TextField source="name" label="Name" />
      <DateField source="updated_at" label="Update Date" />
      <DateField source="created_at" label="Creation Date" />
      <DeleteWithConfirmation {...props}/>
    </Datagrid>
  </List>
);

const AlertsModal = ({ data, loading, handleClick, updateParentState, metricType, defaultMinMaxValue, alertsObj, ...props }) => {
  const { min, max, emails, dataPoints } = alertsObj;
  const form = useForm();
  const [showDialog, setShowDialog] = useState(false);
  const [localMin, setLocalMin] = useState(min);
  const [localMax, setLocalMax] = useState(max);
  const [localEmails, setLocalEmails] = useState(emails);
  const [localInterval, setLocaInterval] = useState(dataPoints);
  const [update, setUpdate] = useState(true);

  useEffect(() => { setLocalMin(min); setUpdate(true)}, [min] );
  useEffect(() => { setLocalMax(max); setUpdate(true)}, [max] );

  const handleCheckAlert = (id) => {
    const processResponse = (response) => {
			const title = 'Alert Check Notification';
			if (response && response.success) {
				NotificationManager.success(response.message, title);
			} else if (response) {
				NotificationManager.warning(response.message, title);
			} else {
				NotificationManager.error('No response from the server', 'Client Notification');
			}
		}
    let options = { headers: new Headers() }
    options.headers.set('accept', 'application/json');
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    const url = `${window.nobid_endpoint}/realtimeCheckAlerts/${id}`;
    fetch(url, options).then((response) => {
      processResponse(response.json);
    });
  }
  const handleDialogClick = () => {
    setShowDialog(true);
    handleClick();
  };
  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSave = () => {
    const { errors } = form.getState();
    if(!(errors?.alerter?.min || errors?.alerter?.max || errors?.alerter?.data_points)) {
      updateParentState({dataPoints: localInterval, min: localMin, max: localMax, emails: localEmails});
      handleCloseClick();
    }
  };

  const handleCancel = () => {
    ['data_points', 'min', 'max', 'emails'].forEach(x => form.change(`alerter.${x}`, form.getFieldState(`alerter.${x}`).initial))
    handleCloseClick();
  };

  const formatedSeries = useMemo(() => {
    return (data.length > 0) ?
      data.map(x=> ({
        name: x[0]?.today || 'Imps',
        type: x[0]?._type || 'column',
        color: x[0]?._color || 'yellow',
        zIndex: x[0]?._zindex || 0,
        data: x.map(y => Array.isArray(y[metricType]) ?
        ({x: new Date(y.date).getTime(), low: Number((y[metricType][0]-(y[metricType][0] *(Number(localMin)/100))).toFixed(2)), high: Number((y[metricType][0]*((Number(localMax)/100)+1)).toFixed(2))}) :
        ({x: new Date(y.date).getTime(), y: Number(y[metricType].toFixed(2))})).slice(14)
      })) : data;
  }, [localMin, localMax, data.filter(x => x.length > 0)?.length]);

  const plotOptions = {
    series: { "turboThreshold": 5000 },
    arearange: { marker: { enabled: false } },
    line: { marker: { enabled: false } },
  };

  return (
    <>
      <div>
      <Button onClick={function() {handleCheckAlert(props.id)}} label='Check Alert' className='MuiButton-containedPrimary' style={{height: '45px', marginTop: '8px', padding: '0 20px'}}/>
      <Button onClick={handleDialogClick} label='EDIT' className='MuiButton-containedPrimary' style={{height: '45px', marginTop: '8px', marginLeft: '8px', padding: '0 20px'}}/>
      </div>
      <Dialog
        maxWidth="md"
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label="Create post"
      >
        <DialogTitle>Alert Edit (60 min)</DialogTitle>
        <DialogContent style={{minHeight: '380px', display: 'grid', gridTemplateRows: 'auto 1fr'}}>
          <Box display='flex' justifyContent='space-between'>
            <Box display='flex' style={{gap: '20px'}} width='100%'>
              <NumberInput source='alerter.data_points' label='Interval (min)' onChange={(v) => { setUpdate(false); setLocaInterval(v.target.value) }} style={{width: '16%'}} defaultValue={4} validate={[required(), minValue(1)]}/>
              <NumberInput source='alerter.min' label='Min (%)' defaultValue={defaultMinMaxValue} onChange={(v) => { setUpdate(true); setLocalMin(v.target.value) }} style={{width: '15%'}} validate={[minValue(0)]}/>
              <NumberInput source='alerter.max' label='Max (%)' defaultValue={defaultMinMaxValue} onChange={(v) => { setUpdate(true); setLocalMax(v.target.value) }} style={{width: '15%'}} validate={[minValue(0)]}/>
              <TextInput source="alerter.emails" label="Destination Notification Emails (comma separated)" onChange={(v) => { setUpdate(false); setLocalEmails(v.target.value) }} fullWidth/>
            </Box>
          </Box>
          { loading ? <CircularProgress style={{alignSelf: 'center', justifySelf: 'center'}}/> :
            <NoBidChartComponent
              config={{ height: '40%', width: '100%', min: 0, xformat: '%e-%b %H:%M', color: 'limegreen' }}
              series={formatedSeries}
              plotOptions={plotOptions}
              legend={{enabled: false}}
              title={choicesType.find(x => x.id === metricType)?.name}
              update={update}
            />
          }
        </DialogContent>
        <DialogActions>
           <Button onClick={handleCancel} label='CANCEL' style={{height: '45px', marginTop: '8px', padding: '0 20px'}}/>
           <Button onClick={handleSave} label='ACCEPT' className='MuiButton-containedPrimary' style={{height: '45px', marginTop: '8px', padding: '0 20px'}}/>
        </DialogActions>
      </Dialog>
    </>
  )
}
